export const parseCustomDate = (dateStr) => {
    if (!dateStr) return null;
    
    let date = new Date(dateStr);
    if (!isNaN(date.getTime())) return date;

    try {
        const parts = dateStr.toString().split(' ').filter(p => p);
        if (parts.length >= 6) {
            const monthMap = {
                'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04', 'May': '05', 'Jun': '06',
                'Jul': '07', 'Aug': '08', 'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
            };
            const month = monthMap[parts[1]];
            if (month) {
                const isoString = `${parts[5]}-${month}-${parts[2]}T${parts[3]}`;
                date = new Date(isoString);
                if (!isNaN(date.getTime())) return date;
            }
        }
    } catch (e) {
        // console.error("Error parsing date:", dateStr, e);
    }
    return null;
};

export const formatDate = (dateStr) => {
    const date = parseCustomDate(dateStr);
    if (date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return dateStr;
};